var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("serverChannel")
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("showTestServer")
                  },
                  on: { change: _vm.serverChannelChange },
                  model: {
                    value: _vm.show_test,
                    callback: function($$v) {
                      _vm.show_test = $$v
                    },
                    expression: "show_test"
                  }
                },
                _vm._l(_vm.serverType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("server")
                  },
                  on: { change: _vm.severChange },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.selectAll },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("selectAll")) + " ")]
                  ),
                  _vm._l(_vm.serverListYJ, function(item) {
                    return _c("el-option", {
                      key: item.serverID,
                      attrs: { label: item.serverName, value: item.serverID }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("roleId"), clearable: "" },
                model: {
                  value: _vm.paramsData.role_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "role_id", $$v)
                  },
                  expression: "paramsData.role_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("isRecalled")
                  },
                  model: {
                    value: _vm.paramsData.is_recalled,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "is_recalled", $$v)
                    },
                    expression: "paramsData.is_recalled"
                  }
                },
                _vm._l(_vm.stateType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-date-picker", {
                staticStyle: { "min-width": "237px" },
                attrs: {
                  clearable: "",
                  "picker-options": _vm.optionType,
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": _vm.$t("range"),
                  "start-placeholder": _vm.$t("startDate"),
                  "end-placeholder": _vm.$t("endDate")
                },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  placeholder: _vm.$t("daysNotLoggedIn"),
                  clearable: ""
                },
                model: {
                  value: _vm.paramsData.loss_days,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "loss_days", $$v)
                  },
                  expression: "paramsData.loss_days"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  placeholder: _vm.$t("cumulativeAmountFilter"),
                  clearable: ""
                },
                model: {
                  value: _vm.paramsData.total_amount,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "total_amount", $$v)
                  },
                  expression: "paramsData.total_amount"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 8 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.options.length },
                  on: { click: _vm.batchInvite }
                },
                [_vm._v(" " + _vm._s(_vm.$t("batchSendInvitation")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.exportLoading },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { prop: "game", label: _vm.$t("game"), "min-width": "120" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "channel",
              label: _vm.$t("channel"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pkg",
              label: _vm.$t("packageName"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ad_channel",
              label: _vm.$t("adChannel"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ad_placement",
              label: _vm.$t("adPosition"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "server_name",
              label: _vm.$t("serverName"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "user_id_str",
              label: _vm.$t("userId"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "role_id",
              label: _vm.$t("roleId"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "role_name",
              label: _vm.$t("roleName"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "phone",
              label: _vm.$t("phoneNumber"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "total_amount",
              label: _vm.$t("accumulatedRechargeAmount"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "last_login_time",
              label: _vm.$t("lastLoginTime"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "last_recharge_time",
              label: _vm.$t("lastRechargeTime"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "last_send_time",
              label: _vm.$t("lastInviteTime"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "loss", label: _vm.$t("isLost") }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("operation"), width: "210", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.addInviteItemData([row])
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("invite")) + " ")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.viewInviteList.init(row)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("inviteHistory")) + " ")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      row.vip_state == 2
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn colorG",
                              on: {
                                click: function($event) {
                                  return _vm.vipCallBack(row)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("notRecalled")) + " ")]
                          )
                        : _vm._e(),
                      row.vip_state == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.vipCallBack(row)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("recalled")) + " ")]
                          )
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total
        },
        on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
      }),
      _c("viewInviteList", {
        ref: "viewInviteList",
        on: {
          change: function($event) {
            return _vm.getList(_vm.currentPage)
          }
        }
      }),
      _c("addInviteItem", { ref: "addInviteItem" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }